'use es6';

import Sanitize from 'sanitize';
export const buildSanitizer = config => {
  return new Sanitize(config);
};